<template>
    <div>
        <div v-if="this.lastNews">
            <div class="media" v-bind:key="key" v-for="(value, key) of this.lastNews">
                <div class="media-left">
                    <img class="media-object" :src="value.cover.sizes['512']" :alt="value.cover.alt">
                </div>
                <div class="media-body">
                    <h3 class="media-heading">
                        <a :href="'/news/' + value.slug">{{ truncateTitle(value.title) }}</a>
                    </h3>
                    <p>{{ value.data_pubblicazione }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
           getLastNews() {
               window.axios.get(window.base_url + 'news/latest').then( res => {
                  this.lastNews = res.data.data;
               })
           },
           truncateTitle(title) {
               if(title.length > 47) {
                   return title.substring(0,47)+"...";
               } else {
                   return title;
               }
           }
        },
        mounted() {
           this.getLastNews();
        },
        data() {
            return {
                lastNews: null
            }
        }
    }
</script>

<style>
    .media-object {
       width: 100px;
    }
</style>
